import { Component, OnInit } from '@angular/core';
import { SubmitBugEnvironment } from '@app/enums/submit-bug-environment.enum';
import { environment } from '@environments/environment';
import { CollectorOptions } from 'ngx-jira-issue-collector';

@Component({
  selector: 'app-submit-bug',
  templateUrl: './submit-bug.component.html',
  styleUrls: ['./submit-bug.component.scss'],
  standalone: false,
})
export class SubmitBugComponent implements OnInit {
  isProd: boolean;

  constructor() {}

  /**
   * JIRA issue collector configuration
   * See https://www.npmjs.com/package/ngx-jira-issue-collector
   */
  environment: any = {
    Location: window.location.href,
    Referrer: document.referrer,
    'User-Agent': navigator.userAgent,
    'Screen Resolution': screen.width + ' x ' + screen.height,
    Environment: this.getEnvironment(),
  };

  config: CollectorOptions = {
    baseUrl: environment.atlassian.url,
    collectorId: environment.atlassian.collector_id,
    recordWebInfo: true,
    fieldValuesFn: () => {
      const fieldArray: string[] = [];
      for (const prop in this.environment) {
        if (prop) {
          fieldArray.push(prop + ': ' + this.environment[prop]);
        }
      }
      return {
        environment: fieldArray.join('\n'),
      };
    },
  };

  /**
   * OnInit determine if this submit bug component will appear based on the environment configuration.
   */
  ngOnInit(): void {
    // NOTE: Don't use the envService.
    this.isProd = environment.production ? true : false;
  }

  /**
   * Return current window location based on current environment
   * @returns - returns environment string
   */
  getEnvironment(): string {
    if (window.location.href.indexOf('localhost') > -1) {
      return SubmitBugEnvironment.LOCAL_ENVIRONMENT;
    } else if (window.location.href.indexOf('inindca') > -1) {
      return SubmitBugEnvironment.SANDBOX_ENVIRONMENT;
    } else if (window.location.href.indexOf('inintca') > -1) {
      return SubmitBugEnvironment.SANDBOX_ENVIRONMENT;
    } else {
      return SubmitBugEnvironment.PRODUCTION_ENVIRONMENT;
    }
  }
}
